import { Label } from "@shared/ui/label";
import type { ReactNode } from "react";

type TProfileSection = {
	title: string;
	description: string;
	name: string;
	children: ReactNode;
};

export default function ProfileSection({ title, description, name, children }: TProfileSection) {
	return (
		<div className="flex items-center justify-between">
			<div className="space-y-0.5">
				<Label htmlFor={name}>{title}</Label>
				{description && <p className="text-sm text-muted-foreground">{description}</p>}
			</div>
			{children}
		</div>
	);
}
